export default class ApplicationConfirmPage {
  init() {
    const root = document.getElementById('application-confirm');
    if (!root) {
      return;
    }

    const formUrl = root.dataset.applicationFormUrl;
    const thanksUrl = root.dataset.applicationThanksUrl;
    const rawData = sessionStorage.getItem('application_data');

    if (!rawData) {
      if (formUrl) {
        window.location.href = formUrl;
      }
      return;
    }

    let data;
    try {
      data = JSON.parse(rawData);
    } catch (error) {
      sessionStorage.removeItem('application_data');
      if (formUrl) {
        window.location.href = formUrl;
      }
      return;
    }

    Object.keys(data).forEach((key) => {
      const displayEl = document.querySelector(`[data-display="${key}"]`);
      if (displayEl) {
        const value = String(data[key] ?? '');
        const lines = value.split('\n');

        displayEl.textContent = '';
        lines.forEach((line, index) => {
          if (index > 0) {
            displayEl.appendChild(document.createElement('br'));
          }
          displayEl.appendChild(document.createTextNode(line));
        });
      }

      const hiddenEl = document.getElementById(`confirm-${key}`);
      if (hiddenEl) {
        hiddenEl.value = data[key];
      }
    });

    document.addEventListener(
      'wpcf7mailsent',
      () => {
        sessionStorage.removeItem('application_data');
        if (thanksUrl) {
          window.location.href = thanksUrl;
        }
      },
      false,
    );

    if (
      window.location.search.indexOf('wpcf7-f') !== -1 ||
      window.location.hash.indexOf('wpcf7') !== -1
    ) {
      const responseMsg = document.querySelector('.wpcf7-mail-sent-ok');
      if (responseMsg) {
        sessionStorage.removeItem('application_data');
        if (thanksUrl) {
          window.location.href = thanksUrl;
        }
      }
    }
  }
}
